import NewEventButton from "./new_event_button"
import SettingsMenu from "./settings_menu"
import ChurchCenterSettings from "components/admin/ChurchCenterSettings/ChurchCenterSettings"
import StaffActionsDropdown from "components/admin/staff_actions_org_dropdown"
import { bool, string } from "prop-types"

const EventsPageHeader = ({
  isAdmin,
  churchCenterEventSort,
  churchCenterEventsUrl,
  churchCenterDisabledOrUnpublished,
  ccaEnabled,
  ccwEnabled,
  ccaRegistrationsPublished,
  ccwRegistrationsPublished,
  subscribedToPublishing,
  isActingStaff
}) => (
  <div className="page__header pb-2">
    <div className="d-f@sm ai-c jc-sb w-100%">
      <div className="d-f">
        <h1 className="d-n d-b@sm mb-0">Signups</h1>
        {isActingStaff && <StaffActionsDropdown />}
      </div>
      <div className="d-f g-1">
        {isAdmin && (
          <SettingsMenu isAdmin={isAdmin} churchCenterEventSort={churchCenterEventSort} />
        )}
        <ChurchCenterSettings
          ccaEnabled={ccaEnabled}
          ccwEnabled={ccwEnabled}
          ccaRegistrationsPublished={ccaRegistrationsPublished}
          churchCenterDisabledOrUnpublished={churchCenterDisabledOrUnpublished}
          ccwRegistrationsPublished={ccwRegistrationsPublished}
          churchCenterEventsUrl={churchCenterEventsUrl}
          churchCenterEventSort={churchCenterEventSort}
          subscribedToPublishing={subscribedToPublishing}
          isAdmin={isAdmin}
        />
        {isAdmin && (
          <>
            {window.isMobile && <div style={{ flexGrow: "1" }}></div>}
            <NewEventButton
              onNewClick={() => {
                Turbolinks.visit(`/signups/new`)
              }}
            />
          </>
        )}
      </div>
    </div>
  </div>
)

EventsPageHeader.propTypes = {
  isAdmin: bool.isRequired,
  churchCenterEventSort: string,
  churchCenterEventsUrl: string.isRequired,
  churchCenterDisabledOrUnpublished: bool,
  ccaEnabled: bool.isRequired,
  ccwEnabled: bool.isRequired,
  ccaRegistrationsPublished: bool.isRequired,
  ccwRegistrationsPublished: bool.isRequired,
  subscribedToPublishing: bool,
  isActingStaff: bool
}

export default EventsPageHeader
